export const useGeolocation = () => {
  const coordinates = ref<{ lat: number; lng: number; accuracy?: number } | null>(null);
  const error = ref<string | null>(null);
  const isSupported = typeof navigator !== 'undefined' && 'geolocation' in navigator;
  const nuxtApp = useNuxtApp()

  const locationCookie = useCookie<{ lat: number; lng: number }>('location', {
    default: () => ({ lat: 0, lng: 0 })
  });

  const checkPermission = async () => {
    if (!navigator.permissions) return;
    try {
      const status = await navigator.permissions.query({ name: 'geolocation' as PermissionName });
      if (status.state === 'denied' || status.state === 'prompt') {
        error.value = 'Location permission denied. Enable it in browser settings.';
      }
    } catch (e) {
      console.error('Error checking permissions:', e);
    }
  };
  
  const fetchLocation = () => {
    if (!isSupported) {
      error.value = 'Geolocation not supported';
      return;
    }
    // Prevent multiple fetches

    checkPermission();
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const { latitude, longitude, accuracy } = pos.coords;
        coordinates.value = { lat: latitude, lng: longitude, accuracy };
        // Save to cookie if not already saved

        console.log('locationCookie.value.lat != latitude' , locationCookie.value.lat != latitude);

        if (locationCookie.value.lat != latitude) {
          locationCookie.value = { lat: latitude, lng: longitude };
          setTimeout(() => {
            console.log('location:registered');
            nuxtApp.$bus.emit('location:registered', locationCookie.value)
          }, 500);
        }
      },
      (err) => {
        error.value = `Geolocation error (${err.code}): ${err.message}`;
        console.error(error.value);
      },
      {
        enableHighAccuracy: true,
        timeout: 15000,
        maximumAge: 0
      }
    );
  };
  return { coordinates, error, fetchLocation, isSupported };
};
